import { Map } from 'immutable'
import { createSelector } from 'reselect'

import { getDevFlags, LDFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

const getFeatureFlagState = (state: Map<string, any>) => state?.get('featureFlag')

const getFeatureFlags = createSelector([getFeatureFlagState], (featureFlagState) => ({
  ...(featureFlagState.get('flags').toJS() as LDFlags),
  ...getDevFlags(),
}))

export const getAdultTriageDisabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.adultTriageDisabled,
)

export const getForceAdultFlowsToHPI = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.forceAdultFlowsToHPI,
)

export const getIsCustomerDynamicSessionLimitFeatureFlagEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isCustomerDynamicSessionLimitEnabled,
)

export const getIsCopayForMaxCostEstimateEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isCopayForMaxCostEstimateEnabled,
)

export const getIsCarelonOutpatientTherapyEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isCarelonOutpatientTherapyEnabled,
)

export const getIsFavoritedProvidersEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isFavoritedProvidersEnabled,
)

export const getForkedTriageV2Enabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.forkedTriageV2Enabled,
)

export const getShouldShowWalmartHPICostTransparency = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.shouldShowWalmartHPICostTransparency,
)

export const getIsClientDisabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isClientDisabled,
)

export const getIsDBTTeensEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isDBTTeensEnabled,
)

export const getShouldSurfaceNPEvalHPIScreen = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.shouldSurfaceNPEvalHPIScreen ?? false,
)

export const getIsPromotionalSMSEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isPromotionalSMSEnabled,
)

export const getIsStripeTextToPayEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isStripeTextToPayEnabled,
)

export const getShowProviderAdjectives = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.showProviderAdjectives,
)

export const getIsEapHpiInProductNotificationsEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isEapHpiInProductNotificationsEnabled,
)

export const getIsOnsiteEligibleResponseEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isOnsiteEligibleResponseEnabled,
)

export const getIsOnsiteEntrypointsEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isOnsiteEntrypointsEnabled,
)

export const getIsMultipleOnsiteIPCLocationEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isMultipleOnsiteIPCLocationEnabled,
)

export const getShowLyraSelectStateOfEmergencyBanner = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.showLyraSelectStateOfEmergencyBanner,
)

export const getIsUserPatchEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isUserPatchEnabled ?? false,
)

export const getIsUSTerritoryDeprecationEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isUSTerritoryDeprecationEnabled ?? false,
)

export const getAreConservativeGlobalPreferencesEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.areConservativeGlobalPreferencesEnabled,
)

export const getIsOUSNeuroEnabled = createSelector(
  getFeatureFlags,
  (featureFlagState) => featureFlagState?.isOUSNeuroEnabled ?? false,
)
